import { render, staticRenderFns } from "./Uploadfield.vue?vue&type=template&id=5cdbe8cd"
import script from "./Uploadfield.vue?vue&type=script&lang=ts"
export * from "./Uploadfield.vue?vue&type=script&lang=ts"
import style0 from "./Uploadfield.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports